exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-results {\n  list-style: none;\n  padding: 0;\n  margin: 0 auto 5rem;\n}\n.search-results li + li {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 0.1rem solid #CFCFCF;\n}\n.toolbar .toolbar__filters .form__group {\n  width: 16.3rem;\n}\n.download .btn {\n  margin-top: 2.1rem;\n}\n@media screen and (max-width: 1310px) {\n.toolbar .toolbar__filters .form__group + .form__group {\n    margin-left: 1rem;\n}\n.toolbar .toolbar__filters .form__group {\n    width: 15.5rem;\n}\n}\n@media screen and (max-width: 991px) {\n.download .btn-download {\n    display: initial;\n}\n}", ""]);

// exports
